<template>
  <section v-if="isFavorietsEnable">
    <button
      class="px-4 rounded font-sf-pro text-center flex items-center justify-center relative gap-2 text-lg rounded-full h-10 bg-white text-gray-900 cursor-pointer font-normal h-12 lg:px-6 text-base lg:text-xl"
      @click="isFavorite = !isFavorite"
      @mouseover="isHover = true"
      @mouseleave="isHover = false"
    >
      <div class="relative w-4 h-4">
        <t-icon-favoriteBlack
          class="w-full h-full absolute -top-0 left-0"
          :class="
            [!isFavorite
               ? 'opacity-[10] transition-all duration-700'
               : 'opacity-0 transition-all duration-700',
             isHover ? 'scale-[1.2] transition-all duration-100':'']
          "
        />
        <t-icon-like-red
          class="w-full h-full absolute -top-0 left-0"
          :class="
            isFavorite
              ? 'opacity-[10] transition-all duration-700'
              : 'opacity-0 transition-all duration-700'
          "
        />
      </div>
      <div class="whitespace-nowrap">
        В избранное
      </div>
    </button>
  </section>
</template>

<script setup lang="ts">
const isFavorite = ref(false)
const isHover = ref(false)

const isFavorietsEnable = false
</script>
